import { Injectable, inject } from '@angular/core';
import { SiaSessionParam } from '../interfaces/sia-session-param';
import { SiaHttpService } from '../services/http.service';
@Injectable({
  providedIn: 'root',
})
export class SiaReportPrintApi {
  private api = inject(SiaHttpService);

  private apiController: string = 'reports-manager';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  downloadReport(params: { reportName: string; reportParams: SiaSessionParam[] }) {
    return this.api
      .post(`${this.apiController}`, params, {
        responseType: 'blob',
      })
      .catch((ex) => {});
  }

  saveReport(params: { reportName: string; reportParams: SiaSessionParam[] }): Promise<string> {
    return this.api.post(`${this.apiController}/save`, params);
  }

  saveReportToPath(params: {
    reportName: string;
    reportParams: SiaSessionParam[];
    destinationPath: string;
    fileName?: string;
    mode?: 'pdf' | 'image';
  }): Promise<string> {
    return this.api.post(`${this.apiController}/save-to-path`, params);
  }
}
